export enum BotPageTab {
    develop,
    channels,
    settings,
    publishing
}
export const debugAllTabs = false;


// WEBPACK FOOTER //
// ./Client/Views/BotTabPage.tsx